import {combineReducers} from "redux"
import authority, * as fromAuthority from "./authority/authorityReducer"
import bypassedAuthentication, * as fromBypassedAuthentication from "./bypassedAuthentication/bypassedAuthenticationReducer"
import details, * as fromDetails from "./details/detailsReducer"

/**
 * User reducer.
 */
const user = combineReducers({
    authority: authority(),
    bypassedAuthentication,
    details,
})

export default user

// OPERATIONS ON AUTHORITY
/**
 * Get the token from the state.
 */
export const getMfaSessionId = state => fromAuthority.getMfaSessionId(state.authority)
/**
 * Get the token from the state.
 */
export const getUserToken = state => fromAuthority.getToken(state.authority)
/**
 * Get the expiration date.
 */
export const getExpirationDate = state => fromAuthority.getExpirationDate(state.authority)
/**
 * Get the user permissions from the state.
 */
export const getUserPermissions = state => fromAuthority.getPermissions(state.authority)

// OPERATIONS ON DETAILS
/**
 * Get user details from the store.
 */
export const getUserDetails = state => fromDetails.getDetails(state.details)

export const getUserDetailsCesu = state => fromDetails.getDetails(state.details.cesu)

export const getUserDetailsSap = state => fromDetails.getDetails(state.details.sap)

// OPERATIONS ON BYPASS AUTHENTICATION
/**
 * Get user details from the store.
 */
export const getBypassedAuthentication = state =>
    fromBypassedAuthentication.getBypassedAuthentication(state.bypassedAuthentication)
